// src/composables/useChangePage.js
// 頁面從第一畫面切換到第二畫面
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import useOverflowCheck from '@/composables/useOverflowCheck'
export default function useChangePage () {
  const router = useRouter() // $router與$route
  const route = useRoute()
  const store = useStore()
  async function changePage (page) {
    console.log(page)
    store.commit('setPage', page)
    router.push(route.path + '/' + page.toLowerCase() + '1')
    store.commit('setPageTitle', store.state.linkpage[page.charCodeAt() - 65].content[0].text)
    const { checkOverflown } = useOverflowCheck()
    setTimeout(() => {
      checkOverflown()
    }, 1000)
  }
  return {
    changePage
  }
}
